<template>
    <article class="thank-you-page">
        <AppHeader/>
        <FormHeader/>
        <ShowStep :current="3"/>
        <div class="section-bg">
            <div class="header-title mt-8">
                <h1>
                    認定登録申し込み完了
                </h1>
            </div>
        </div>
        <SectionLabel>お申し込みありがとうございました。</SectionLabel>
        <div class="contact-info">
            <ul>
                <li>
                    <h6>お問い合わせ</h6>
                    <p>contact@jhma.or.jp</p>
                </li>
            </ul>
            <p>
                受付時間／10:00〜17:00（土曜・日曜・祝日を除く）
            </p>
        </div>
        <section class="content p-2 mt-12">
            <a href="https://jhma.or.jp/" class="link">
                トップページに戻る
            </a>
        </section>
        <NarrowFooter/>
    </article>
</template>

<script>
import AppHeader from "../../parts/app/AppHeader";
import RightBanner from "../../parts/app/RightBanner";
import SectionLabel from "../../parts/app/SectionLabel";
import ShowStep from "../../parts/app/ShowStep";
import FormHeader from "../../parts/app/FormHeader";
import NarrowFooter from "../../parts/app/NarrowFooter";
import { clearFormData } from "../../utils/formDataCookie";
export default {
    name: "ThankYou",
    components: { AppHeader, RightBanner, ShowStep, SectionLabel, FormHeader, NarrowFooter },
    mounted() {
        // 決済完了後、Cookieに保存されたフォームデータをクリア
        clearFormData();
    }
}
</script>

<style scoped>
.contact-info {
    @apply max-w-full mx-auto mt-8 p-8;
    width: 800px;
    background-color: #f2f8fb;
}

.contact-info ul {
    @apply flex flex-col lg:flex-row justify-center;
}

.contact-info ul li {
    @apply lg:text-center flex-1 relative;
}

.contact-info ul li:not(:first-of-type) {
    @apply mt-4 lg:mt-0;
}

.contact-info ul li:not(:last-of-type):after {
    @apply absolute h-full top-0 bottom-0 right-0 hidden lg:block;
    content: "";
    background-color: #dfe8ec;
    width: 1px;
}

.contact-info ul li h6 {
    font-size: 16px;
    letter-spacing: 0.12em;
}

.contact-info ul li p {
    @apply mt-2;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0.12em;
    color: #006098;
}

.contact-info > p {
    @apply mt-8 lg:text-center;
    font-size: 14px;
    letter-spacing: 0.1em;
}
</style>
